<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">{{id ? 'Edit' : 'Create'}} Domain</span>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-content">
                <div class="columns">
                    <div class="column is-6">
                        <b-field label="Display Name">
                            <b-input v-model="data.display_name"/>
                        </b-field>
                        <b-field label="Value">
                            <b-input v-model="data.value"/>
                        </b-field>
                        <b-field label="Main Gatekeeper">
                            <b-select v-model="data.gatekeeper_id" expanded>
                                <option :value="null">All</option>
                                <option :value="gatekeeper.id" v-for="(gatekeeper, index) in gatekeepers" :key="index" :disabled="gatekeeper.attributes.deleted_at">{{gatekeeper.attributes.email}}</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column is-6">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>App Access</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="app in apps" :key="`app_${app.id}`">
                                    <td>
                                        <b-checkbox type="is-info"
                                            :native-value="app.id"
                                            v-model="data.applications">
                                            {{ app.name }}
                                        </b-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <section class="m-t-md">
                    <router-link :to="{ name: 'users' }" class="button is-default m-r-sm">Cancel</router-link>
                    <b-button id="btn-save" type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                </section>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
export default {
    data(){
        return {
            data:{
                display_name:null,
                value:null,
                applications:[],
                gatekeeper_id:null
            },
            apps:[],
            gatekeepers:[]
        }
    },
    computed:{
        id(){
            return this.$router.currentRoute.params.id
        }
    },
    mounted(){
        if(this.id){
            this.getTag()
        }
        this.getGatekeepers()
        this.getApps()
    },
    methods:{
        save(){
            if(this.id){
                return Vue.$tagService.updateTag(this.id,this.data).then(()=>{
                    this.$buefy.toast.open({
                        type:'is-success',
                        message:'Tag updated!'
                    })
                    this.$router.push({name:'users',query:{tabSelected:'domains'}});
                })
            }
            return Vue.$tagService.createTag(this.data).then(()=>{
                this.$buefy.toast.open({
                    type:'is-success',
                    message:'Tag added!'
                })
                this.$router.push({name:'users',query:{tabSelected:'domains'}});
            })
        },
        getGatekeepers(){
            let params = '?roles=gatekeeper'
            if(this.id){
                params = params + '&trashed=true'
            }
            Vue.$userService.userList(params).then((response)=>{
                this.gatekeepers = response.data
            })
        },
        getTag(){
            Vue.$tagService.getTag(this.id,`?includes=applications`).then((response)=>{
                this.data.display_name = response.data.attributes.display_name
                this.data.value = response.data.attributes.value
                this.data.gatekeeper_id = response.data.attributes.gatekeeper_id
                this.data.applications =  response.included ? response.included.filter(element=>element.type==='application').map(element=>element.id) : []
            })
        },
        getApps(){
            Vue.$appService.appList().then((response)=>{
                this.apps = response
            })
        }
    }
}
</script>